import { atom } from 'recoil';
import tagOptions from 'constants/tagOptions';
export const unregisterVehicle = atom({
  key: 'unregisterVehicle',
  default: undefined
});
export const unregisterVehicles = atom({
  key: 'unregisterVehicles',
  default: []
});
export const currentTagOption = atom({
  key: 'currentTagOption',
  default: tagOptions.KEEP_AND_REUSE
});
export const confirmInfo = atom({
  key: 'confirmInfo',
  default: false
});